import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconResetLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.289 20c-2.01 0-3.782-.613-5.316-1.84-1.533-1.227-2.516-2.797-2.948-4.71a.621.621 0 0 1 .097-.548.693.693 0 0 1 .504-.29.78.78 0 0 1 .55.12.845.845 0 0 1 .34.476c.38 1.545 1.2 2.813 2.46 3.804 1.26.992 2.697 1.488 4.313 1.488 1.95 0 3.604-.68 4.962-2.038 1.358-1.358 2.038-3.012 2.038-4.962 0-1.95-.68-3.604-2.038-4.963C15.893 5.18 14.24 4.5 12.29 4.5a6.683 6.683 0 0 0-3.071.728A7.557 7.557 0 0 0 6.75 7.231h1.866c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534a.725.725 0 0 1-.534.216H5.193a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644V4.404c0-.213.072-.39.215-.534a.726.726 0 0 1 .535-.216c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534v1.619a8.487 8.487 0 0 1 2.915-2.23A8.368 8.368 0 0 1 12.29 3c1.18 0 2.285.223 3.315.67A8.609 8.609 0 0 1 18.3 5.488a8.61 8.61 0 0 1 1.82 2.695 8.257 8.257 0 0 1 .669 3.316c0 1.18-.223 2.285-.67 3.315a8.607 8.607 0 0 1-1.819 2.697 8.607 8.607 0 0 1-2.696 1.819 8.254 8.254 0 0 1-3.314.67Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconResetLine;
